module.exports = __webpack_public_path__ + "img/milestone-memo.fff1fd17.png";